"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 추가 액션 메뉴를 여는 버튼.
 */
let MoreButton = class MoreButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.ariaLabel = '더보기';
        this.ariaExpanded = 'false';
        this.ariaControls = null;
        this.ariaHasPopup = 'menu';
        this.tooltipPlacement = 'bottom';
        this.disabled = false;
    }
    render() {
        return (0, icon_button_utils_1.renderIconAction)({
            icon: icon_names_1.ICON_NAMES.MORE_ACTIONS,
            ariaLabel: this.ariaLabel,
            tooltipPlacement: this.tooltipPlacement,
            disabled: this.disabled,
            ariaHasPopup: this.ariaHasPopup,
            ariaExpanded: this.ariaExpanded,
            ariaControls: this.ariaControls,
        });
    }
};
MoreButton.styles = [shared_styles_1.resetStyles, icon_button_styles_1.iconButtonStyles, icon_button_styles_1.iconButtonSecondarySkinStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], MoreButton.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-expanded' })
], MoreButton.prototype, "ariaExpanded", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-controls' })
], MoreButton.prototype, "ariaControls", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-haspopup' })
], MoreButton.prototype, "ariaHasPopup", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'tooltip-placement' })
], MoreButton.prototype, "tooltipPlacement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], MoreButton.prototype, "disabled", void 0);
MoreButton = __decorate([
    (0, decorators_js_1.customElement)('mm-more-button')
], MoreButton);
exports.MoreButton = MoreButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9yZS1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJtb3JlLWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBZ0M7QUFDaEMscURBQTJEO0FBSzNELG9FQUFnRTtBQUNoRSwyRkFHMkQ7QUFDM0QseUZBQW9GO0FBQ3BGLCtEQUF5RDtBQUV6RDs7R0FFRztBQUVJLElBQU0sVUFBVSxHQUFoQixNQUFNLFVBQVcsU0FBUSxnQkFBVTtJQUFuQzs7UUFFZ0QsY0FBUyxHQUFHLEtBQUssQ0FBQTtRQUNkLGlCQUFZLEdBQWdCLE9BQU8sQ0FBQTtRQUNuQyxpQkFBWSxHQUFjLElBQUksQ0FBQTtRQUM5QixpQkFBWSxHQUFpQixNQUFNLENBQUE7UUFFM0YscUJBQWdCLEdBQXFCLFFBQVEsQ0FBQTtRQUNoQixhQUFRLEdBQUcsS0FBSyxDQUFBO0lBYS9DLENBQUM7SUFYQyxNQUFNO1FBQ0osT0FBTyxJQUFBLG9DQUFnQixFQUFDO1lBQ3RCLElBQUksRUFBRSx1QkFBVSxDQUFDLFlBQVk7WUFDN0IsU0FBUyxFQUFFLElBQUksQ0FBQyxTQUFTO1lBQ3pCLGdCQUFnQixFQUFFLElBQUksQ0FBQyxnQkFBZ0I7WUFDdkMsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRO1lBQ3ZCLFlBQVksRUFBRSxJQUFJLENBQUMsWUFBWTtZQUMvQixZQUFZLEVBQUUsSUFBSSxDQUFDLFlBQVk7WUFDL0IsWUFBWSxFQUFFLElBQUksQ0FBQyxZQUFZO1NBQ2hDLENBQUMsQ0FBQTtJQUNKLENBQUM7O0FBbkJNLGlCQUFNLEdBQUcsQ0FBQywyQkFBVyxFQUFFLHFDQUFnQixFQUFFLGtEQUE2QixDQUFDLENBQUE7QUFDekI7SUFBcEQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsWUFBWSxFQUFFLENBQUM7NkNBQWtCO0FBQ2Q7SUFBdkQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsZUFBZSxFQUFFLENBQUM7Z0RBQW9DO0FBQ25DO0lBQXZELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGVBQWUsRUFBRSxDQUFDO2dEQUErQjtBQUM5QjtJQUF2RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxlQUFlLEVBQUUsQ0FBQztnREFBb0M7QUFFM0Y7SUFEQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxtQkFBbUIsRUFBRSxDQUFDO29EQUNkO0FBQ2hCO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzs0Q0FBaUI7QUFSbEMsVUFBVTtJQUR0QixJQUFBLDZCQUFhLEVBQUMsZ0JBQWdCLENBQUM7R0FDbkIsVUFBVSxDQXFCdEI7QUFyQlksZ0NBQVUifQ==